/**
 *
 * vuex getters
*/

/**
 * 逻辑是这样的 获取到服务端返回的菜单
 * 根据服务端返回的菜单结合所有动态路由map dynamicRoutes 生成新的 路由
 * 这个新的路由 就是由权限进行控制的
 * 在已有的不需要权限的路由中，比如我们的home
 * 根据动态生成的全新的路由生成整个菜单栏
 */

import { constRoutes } from "@/router";//常量路由
import dynamicRoutesMap from "@/router/dynamicRoutes";//动态添加的路由
import {deepMerge} from "@/common/js/utils";

const generateRoutes = (routes, rule)=>{
  return routes;
}

const getters = {
  // 这个变量是符合权限规则的动态路由 之所以写在这里 是考虑到权限规则由后端给予
  dynamicRoutes: (state)=>{
    let _routes = generateRoutes(dynamicRoutesMap);
    return _routes;
  },
  sideBarList: (state, getters)=>{
    let constantRoutes = deepMerge([],constRoutes.filter(item=>item.name=="layout"))[0];
    let dynamicRoutes = deepMerge([],getters.dynamicRoutes);
    constantRoutes.children.push(...dynamicRoutes);

    let sideBarRoutes = constantRoutes.children;
    let sideBar = [];
    sideBar = sideBarRoutes.map(route=>{
      let tmp = {};
      tmp["path"] = route.path;
      tmp["name"] = route.name;
      if(route.meta && route.meta.title){
        tmp["title"] = route.meta.title;
      }
      if(route.meta && route.meta.icon){
        tmp["icon"] = route.meta.icon;
      }
      tmp["isPage"] = true;

      if(route.children && route.children.length > 0){
        tmp["isPage"] = false;
        tmp.children = route.children.map(child=>{
          let obj = {};
          obj["path"] = `${route.path}/${child.path}`;
          obj["name"] = child.name;
          if(child.meta && child.meta.title){
            obj["title"] = child.meta.title;
          }
          if(child.meta && child.meta.icon){
            obj["icon"] = child.meta.icon;
          }
          if(child.meta && child.meta.parentName){
            obj["parentName"] = child.meta.parentName;
          }
          return obj;
        });
      }
      return tmp;
    });
    return sideBar;
  }
};

export default getters;
